export const SET_PAGE_TITLE = 'SET_PAGE_TITLE'
